import "./App.scss";
import "./i18n/index";
import {
  LoaderRoot,
  NavigationRoot,
  OutcomeRoot,
  WrapperRoot,
} from "./ui/roots";
import { BrowserRouter } from "react-router-dom";
import { ScrollTopRoot } from "./ui/roots/scroll-top-root/scroll-top.root";

function App() {
  return (
    <BrowserRouter>
      <WrapperRoot>
        <ScrollTopRoot />
        <NavigationRoot />
        <LoaderRoot />
        <OutcomeRoot />
      </WrapperRoot>
    </BrowserRouter>
  );
}

export default App;
